module.exports = __webpack_public_path__ + "static/media/Modenatur-LogoBianco.6ab8b1b6.png";